import { Box, Container, Grid, makeStyles } from '@material-ui/core';
import { useEffect, useMemo, useState } from 'react';
import { HeaderWithButtons } from '../components-molecules/HeaderWithButtons';
import CollectionDashboardItem from '../components-molecules/CollectionDashboardItem';
import { colours } from '../constants/theme';
import { useSelector } from 'react-redux';
import { useAppWebSocket } from '../hooks/useAppWebSocket';
import { ButtonPrimary } from '../components-atoms';
import Add from "@material-ui/icons/Add";
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(() => ({
  container: {},
  kpiContainer: {
    marginTop: 16
  },
  kpiSkeleton: {
    backgroundColor: colours.highEmphasis,
    color: colours.primary,
    padding: 16,
    borderRadius: 8,
    minHeight: 178
  },
  addNewBtn: {
    height: 36,
    width: 160
  }
}));


interface SocketMessage {
  Open: number;
  OpenPremium?: number;
  OutForDelivery: number;
  Delivered: number;
  Failed: number;
}

export function CollectionDashboard() {
  const classes = useStyles();
  const { t } = useTranslation();
  // const [message, setMessage] = useState('');
  const [loading, setLoading] = useState<boolean>(true);
  const userData = useSelector((state: any) => state.login);
  const isAdmin = useMemo(() => userData.role === "Admin", [userData]);
  const { lastJsonMessage } = useAppWebSocket<SocketMessage | null>('/ws/dashboard');

  if (!userData.isCollectEnabled) {
    window.location.href = '/';
  }

  useEffect(() => {
    if (typeof lastJsonMessage?.Open === "number") {
      setLoading(false);
    }
  }, [lastJsonMessage]);

  const handleClickNew = () => {
    window.location.href = `/new-delivery-order`;
  };

  const renderNewBtn = (style?: React.CSSProperties) => {
    if (userData.role === "Admin" || userData.role === "Merchant") {
      return null;
    }

    return (
      <ButtonPrimary
        className={classes.addNewBtn}
        onClick={handleClickNew}
        startIcon={<Add />}
        style={style}
      >
        {t('collectionDashboard.newDelivery')}
      </ButtonPrimary>
    );
  };

  const renderHeader = () => {
    return (
      <Box mb={4}>
        <HeaderWithButtons title={t('collectionDashboard.title')}>
          <Box style={{ display: 'flex', flex: 1, justifyContent: 'flex-end' }}>
            {renderNewBtn()}
          </Box>
        </HeaderWithButtons>
      </Box>
    );
  };

  return (
    <Container className={classes.container}>
      {renderHeader()}

      {loading ? (
        <Grid container spacing={2} className={classes.kpiContainer}>
          {[...Array(4)].map((_, i) => (
            <Grid key={i} item xs={6}>
              <div className={classes.kpiSkeleton} />
            </Grid>
          ))}
        </Grid>
      ) : (
        <Grid container spacing={2} className={classes.kpiContainer}>
          <Grid item xs={6}>
            <CollectionDashboardItem
              title={t('collectionDashboard.open')}
              count={lastJsonMessage?.Open || 0}
            />
          </Grid>
          {isAdmin &&
            <Grid item xs={6}>
              <CollectionDashboardItem title={t('collectionDashboard.openConciergeOrders')} count={lastJsonMessage?.OpenPremium || 0} />
            </Grid>
          }
          <Grid item xs={6}>
            <CollectionDashboardItem
              title={t('collectionDashboard.inTransit')}
              count={lastJsonMessage?.OutForDelivery || 0}
            />
          </Grid>
          <Grid item xs={6}>
            <CollectionDashboardItem
              title={t('collectionDashboard.delivered')}
              count={lastJsonMessage?.Delivered || 0}
            />
          </Grid>
          <Grid item xs={6}>
            <CollectionDashboardItem
              title={t('collectionDashboard.failed')}
              count={lastJsonMessage?.Failed || 0}
            />
          </Grid>
        </Grid>
      )}
    </Container>
  );
}
